import { BLOCK_UNBLOCK_DATE, BLOCK_UNBLOCK_DATE_SUCCESS, BLOCK_UNBLOCK_DATE_ERROR, BLOCK_UNBLOCK_DATE_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const BlockUnblockDate = (state = initialState, action) => {
  switch (action.type) {
    case BLOCK_UNBLOCK_DATE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case BLOCK_UNBLOCK_DATE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case BLOCK_UNBLOCK_DATE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case BLOCK_UNBLOCK_DATE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default BlockUnblockDate;
